import { Select, Option, type SelectProps } from "@tokenterminal/ui/InputV3"
import { useId } from "react"

export type DropdownOption<T> = {
  label: string
  value: T
}

type DropdownProps<T, U = string | undefined> = {
  label?: U
  defaultItem?: T
  selectedItem?: T
  items: Array<DropdownOption<T>>
  onChange: (
    value: U extends undefined ? T : T | null,
    label: U extends undefined ? string : string | null
  ) => void
} & Omit<
  SelectProps,
  "onChange" | "defaultValue" | "id" | "name" | "variant" | "size" | "children"
>

export function Dropdown<T extends string | null | undefined>({
  onChange,
  label,
  defaultItem,
  selectedItem,
  items = [],
  ...props
}: DropdownProps<T>) {
  const id = useId()

  return (
    <Select
      {...props}
      id={id}
      name={id}
      onChange={(e) => {
        const item = items.find((item) => {
          const targetValue = e.target.value
          if (typeof e.target.value === "undefined") {
            return item.value == targetValue
          }

          return item.value === targetValue
        })

        if (item) {
          onChange(item.value, item.label)
        } else {
          onChange(null, null)
        }
      }}
      defaultValue={defaultItem || undefined}
      value={selectedItem || undefined}
    >
      {label ? <Option value="">{label}</Option> : null}
      {items.map((item) => (
        <Option key={label} value={item.value || undefined}>
          {item.label}
        </Option>
      ))}
    </Select>
  )
}
